import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth-routes/admin/users')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/user' })
  },
})
